import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import BootSplash from "@/components/BootSplash";

import Splash from "@/pages/Splash";
import About from "@/pages/About";
import Features from "@/pages/Features";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Payment from "@/pages/Payment";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Onboarding from "@/pages/Onboarding";

import Dashboard from "@/pages/app/Dashboard";
import Training from "@/pages/app/Training";
import Progress from "@/pages/app/Progress";
import CalendarView from "@/pages/app/CalendarView";
import Recovery from "@/pages/app/Recovery";
import Messages from "@/pages/app/Messages";
import Tips from "@/pages/app/Tips";
import Profile from "@/pages/app/Profile";
import Referrals from "@/pages/app/Referrals";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminAthletes from "@/pages/admin/AdminAthletes";
import AdminPrograms from "@/pages/admin/AdminPrograms";
import AdminBroadcast from "@/pages/admin/AdminBroadcast";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminCodes from "@/pages/admin/AdminCodes";
import AdminReferrals from "@/pages/admin/AdminReferrals";
import AdminTips from "@/pages/admin/AdminTips";

function App() {
  return (
    <AuthProvider>
      <BootSplash />
      <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#111", color: "#fff", border: "1px solid #d7ff0040" } }} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Splash />} />
          <Route path="/about" element={<About />} />
          <Route path="/goals" element={<Navigate to="/features" replace />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/packages" element={<Pricing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />

          <Route path="/app/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/app/training" element={<ProtectedRoute><Training /></ProtectedRoute>} />
          <Route path="/app/progress" element={<ProtectedRoute><Progress /></ProtectedRoute>} />
          <Route path="/app/calendar" element={<ProtectedRoute><CalendarView /></ProtectedRoute>} />
          <Route path="/app/recovery" element={<ProtectedRoute><Recovery /></ProtectedRoute>} />
          <Route path="/app/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
          <Route path="/app/tips" element={<ProtectedRoute><Tips /></ProtectedRoute>} />
          <Route path="/app/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/app/referrals" element={<ProtectedRoute><Referrals /></ProtectedRoute>} />
          <Route path="/app/strava/callback" element={<Navigate to="/app/profile" replace />} />

          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminDashboard />} />
            <Route path="athletes" element={<AdminAthletes />} />
            <Route path="programs" element={<AdminPrograms />} />
            <Route path="codes" element={<AdminCodes />} />
            <Route path="referrals" element={<AdminReferrals />} />
            <Route path="tips" element={<AdminTips />} />
            <Route path="messages" element={<AdminMessages />} />
            <Route path="broadcast" element={<AdminBroadcast />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
